import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-geographic-distribution-report',
  imports: [ReportRunnerComponent],
  templateUrl: './geographic-distribution-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeographicDistributionReportComponent {}
